import { render } from "./SwitchDealer.vue?vue&type=template&id=71b8c9be"
import script from "./SwitchDealer.vue?vue&type=script&lang=js"
export * from "./SwitchDealer.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__